import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import { getSubCategories, getCategories } from "../../redux/actions/indexActions";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { MdAdd } from "react-icons/md";
import { Input } from "reactstrap";
import Pagination from "../../Components/Paginate";
import { CSVLink } from 'react-csv'
import { BiSolidFileExport } from "react-icons/bi";
import SubCategoryGallery from "./SubCategoryGallery";

const Subcategory = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: { subCategories, subCategoryCount, categoriesList },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('desc');
  const [loading2, setLoading2] = useState(true);
  const [paginate, setPaginate] = useState(10);
  const [categoryFilter, setCategoryFilter] = useState("");
  const [refresh, setRefresh] = useState(0);
  const [priority, setPriority] = useState("");
  const [prevData, setPrevData] = useState({
    value: "",
    idx: "",
  });
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;

  useEffect(() => {
    dispatch(getCategories(auth?.token));
  }, [auth]);

  useEffect(() => {
    dispatch(getSubCategories(auth?.token, paginate, page, search, categoryFilter, sort, priority));
  }, [auth?.token, paginate, page, search, categoryFilter, sort, priority,refresh]);

  const handleDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This SubCategory")) {
      axios
        .delete(`/api/admin/v1/sub/category/${id}`, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          dispatch(getSubCategories(auth?.token));
        })
        .catch((err) => {
            if (err.response && err.response.status === 422) {
                toast.error(err.response.data.message);
            } else if (err.response && err.response.data?.message) {
                toast.error(err.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        });
    }
  };
  const handleStatusChange = (value, idx) => {
    handleStatusSubmit(value, idx);
  }

  const handleStatusSubmit = (value, idx) => {
    setLoading2(false);
    axios.post(`/api/admin/v1/sub-category-priorty-status/status`,
      {
        value: value,
        id: idx,
      }, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    })
      .then(() => {
        setPrevData({
          value: "",
          idx: "",
        });
        setRefresh(refresh => refresh + 1);
        toast.success("priorty updated successfully");
      })
      .catch((error) =>
        toast.error("Somthing Went Wrong")
      );
  };
  const csvHead = [
    [
      "category",
      "title english",
      "title hindi",
      "name english",
      "name hindi",
      "avatar english",
      "avatar hindi",
      "description english",
      "description hindi"
    ],
  ];
  const csvData = subCategories.map((cv) => [
    cv?.category?.name,
    cv?.title_english,
    cv?.title_hindi,
    cv?.name_english,
    cv?.name_hindi,
    cv?.avatar_english,
    cv?.avatar_hindi,
    cv?.description_english,
    cv?.description_hindi,
  ]);
  const exportData = csvHead.concat(csvData);

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="mb-0 text-white">Sub Categories</h5>
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "SUBCATEGORIES" &&
                item?.permission?.permission === "create"
            ) && (
                <Link to="/add-subcategory">
                  <Button className="bg-white text-black" size="sm">
                    <span className="me-2">
                      <MdAdd size={22} />
                    </span>
                    Add Sub Category
                  </Button>
                </Link>
              )}
          </div>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }} >
        <div className="row">
          <div className="col-md-7 mb-2">
            <div className="row">
              <div className="col-md-4">
                <Input size={"sm"}
                  value={search}
                  placeholder="Search By Name"
                  onChange={(({ target: { value } }) => setSearch(value))}
                />
              </div>
              <div className="col-md-4">
                <Input size={"sm"}
                  type="select"
                  name="category"
                  value={categoryFilter} onChange={(({ target }) => setCategoryFilter(target.value))}
                >
                  <option value="">Select Category</option>
                  {categoriesList?.map?.((item) => {
                    return (
                      <option value={item.id} key={item.id}>
                        {item?.name}
                      </option>
                    );
                  })}
                </Input>
              </div>
            </div>
          </div>
          <div className={`col-md-2 ${allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "SUBCATEGORIES" &&
              item?.permission?.permission === "export"
          ) ? "offset-md-2" : "offset-md-3"}`}>
            <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "SUBCATEGORIES" &&
              item?.permission?.permission === "export"
          ) && (
              <div className="col-md-1 mb-2">
                <CSVLink
                  filename={
                    "sub-categories.csv"
                  }
                  className="text-black ms-3"
                  title="Export To CSV"
                  data={exportData}
                >
                  <BiSolidFileExport size={25} />
                </CSVLink>
              </div>
            )}
          <div className="col-md-12">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>SL. No.</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Thumbnail</th>
                  <th>Add Gallery</th>
                  <th>Description</th>
                  <th>Priority</th>
                  {allowedPermissions?.some?.(
                    (item) =>
                      item?.permission?.moduleType === "SUBCATEGORIES" &&
                      (item?.permission?.permission === "edit" || item?.permission?.permission === "delete")
                  ) && (
                      <th>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {subCategories.length === 0 ? (
                  <tr>
                    <td colSpan="6">No data found</td>
                  </tr>
                ) : (<>
                  {subCategories?.map?.((item, index) => {
                    return (
                      <tr key={item.id}>
                        <th scope="row">{index + 1 + page * paginate}</th>
                        <td>{item?.name_english}</td>
                        <td>{item?.category?.name}</td>
                        <td>
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + `/${item?.portrait_image}`}
                            height={45}
                            width={45}
                          />
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "SUBSUBCATEGORIES" &&
                                item?.permission?.permission === "edit"
                            ) && (
                                <Link to={`/subcategory-gallery/${item?.id}`}>
                                  <MdAdd size={22} />
                                </Link>
                              )}

                          </div>
                        </td>
                        <td
                          dangerouslySetInnerHTML={{
                            __html: item?.description_english?.slice(0, 50),
                          }}
                        ></td>
                        <td>
                          <Input size={"sm"} className="col-md-2"
                            type="select"
                            name="priority"
                            value={item.priority}
                            onChange={
                              ({ target: { value } }) =>
                                handleStatusChange(value, item.id)
                            }

                          // onChange={(({ target }) => setPriority(target.value))}
                          >
                            <option value="">Select Priority</option>
                            <option value="1" key="1"> 1 </option>
                            <option value="2" key="2"> 2 </option>
                            <option value="3" key="3"> 3 </option>
                            <option value="4" key="4"> 4 </option>
                            <option value="5" key="5"> 5 </option>
                            <option value="6" key="6"> 6 </option>
                            <option value="7" key="7"> 7 </option>
                            <option value="8" key="8"> 8 </option>
                            <option value="9" key="9"> 9 </option>
                            <option value="10" key="10"> 10 </option>
                            <option value="11" key="11"> 11 </option>
                            <option value="12" key="12"> 12 </option>
                            <option value="13" key="13"> 13 </option>
                            <option value="14" key="14"> 14 </option>
                            <option value="15" key="15"> 15 </option>
                          </Input></td>


                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "SUBCATEGORIES" &&
                                item?.permission?.permission === "edit"
                            ) && (
                                <Link to={`/update-subcategory/${item?.id}`}>
                                  <AiOutlineEdit
                                    size={22}
                                    className="text-warning me-3"
                                  />
                                </Link>
                              )}



                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "SUBCATEGORIES" &&
                                item?.permission?.permission === "delete"
                            ) && (
                                <AiOutlineDelete
                                  size={22}
                                  className="text-danger"
                                  onClick={() => handleDel(item.id)}
                                />
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}</>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input
                type="select"
                id="paginate"
                onChange={e =>
                  setPaginate(
                    e.target.value
                  )
                }
                value={paginate}
                className="paging custom-select custom-select-page m-0"
              >
                <option value="10">
                  10
                </option>
                <option value="20">
                  20
                </option>
                <option value="50">
                  50
                </option>
                <option value="100">
                  100
                </option>
                <option value="200">
                  200
                </option>
                <option value="500">
                  500
                </option>
              </Input>
            </div>
            <div className='col-md-10 text-black d-flex align-items-center ps-3'>
              {subCategoryCount > 0 ? (
                <>
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, subCategoryCount)} of {subCategoryCount} entries
                </>
              ) : (
                <>
                  Showing 0 to 0 of 0 entries
                </>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='d-flex justify-content-end'>
              <Pagination
                pageCount={(subCategoryCount) / paginate}
                onChange={(e) => setPage(e.selected)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subcategory;
